type Action =
  | {type: "START_LOADING"; appId: string}
  | {type: "STOP_LOADING"; appId: string};

type State = Record<string, boolean>;

function statusReducer(state: State, action: Action): State {
  switch (action.type) {
    case "START_LOADING":
      return {...state, [action.appId]: true};
    case "STOP_LOADING":
      return {...state, [action.appId]: false};
    default:
      return state;
  }
}

export {statusReducer};
